import { DropdownStyles } from "../types/styles";
import { defaultThemeStyles } from "./defaultThemeStyles";

export const dropdownDefaultStyles: DropdownStyles = {
  DropdownGeneralBackgroundColour:
    defaultThemeStyles.DropdownGeneralBackgroundColour,
  DropdownGeneralTextColour: defaultThemeStyles.DropdownGeneralTextColour,
  DropdownGeneralPlaceholderColour:
    defaultThemeStyles.DropdownGeneralPlaceholderColour,
  DropdownBorderColour: defaultThemeStyles.DropdownBorderColour,
  DropdownBorderFocusColour: defaultThemeStyles.DropdownBorderFocusColour,
  DropdownBorderRadius: defaultThemeStyles.DropdownBorderRadius,
  DropdownSelectedBackgroundColour:
    defaultThemeStyles.DropdownSelectedBackgroundColour,
  DropdownSelectedTextColour: defaultThemeStyles.DropdownSelectedTextColour,
  OverallGeneralTextColour: defaultThemeStyles.OverallGeneralTextColour,
  DropdownGeneralValidationErrorColour:
    defaultThemeStyles.DropdownGeneralValidationErrorColour,
};
